import React from "react";

export function Input({ label, value, onChange, type = "text", testid, placeholder }) {
  return (
    <div>
      <label className="label-eyebrow block mb-2">{label}</label>
      <input type={type} value={value} placeholder={placeholder || ""} onChange={(e) => onChange(e.target.value)} className="brand-input" data-testid={testid} />
    </div>
  );
}

export function Textarea({ label, value, onChange, rows = 3, testid, placeholder }) {
  return (
    <div>
      <label className="label-eyebrow block mb-2">{label}</label>
      <textarea rows={rows} value={value} placeholder={placeholder || ""} onChange={(e) => onChange(e.target.value)} className="brand-input resize-none" data-testid={testid} />
    </div>
  );
}

export function Select({ label, value, onChange, options, testid }) {
  return (
    <div>
      <label className="label-eyebrow block mb-2">{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} className="brand-input" data-testid={testid}>
        {options.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </div>
  );
}

export const DAYS_OF_WEEK = [
  { key: "Mo", label_ro: "Lu", label_en: "Mo" },
  { key: "Tu", label_ro: "Ma", label_en: "Tu" },
  { key: "We", label_ro: "Mi", label_en: "We" },
  { key: "Th", label_ro: "Jo", label_en: "Th" },
  { key: "Fr", label_ro: "Vi", label_en: "Fr" },
  { key: "Sa", label_ro: "Sa", label_en: "Sa" },
  { key: "Su", label_ro: "Du", label_en: "Su" },
];

export function OpeningHoursEditor({ value = [], onChange }) {
  const slots = Array.isArray(value) ? value : [];
  const update = (i, patch) => {
    const next = slots.map((s, idx) => idx === i ? { ...s, ...patch } : s);
    onChange(next);
  };
  const toggleDay = (i, dayKey) => {
    const cur = slots[i].days || [];
    const has = cur.includes(dayKey);
    update(i, { days: has ? cur.filter((d) => d !== dayKey) : [...cur, dayKey] });
  };
  const addSlot = () => onChange([...slots, { days: [], open: "09:00", close: "18:00" }]);
  const removeSlot = (i) => onChange(slots.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-3" data-testid="opening-hours-editor">
      {slots.map((slot, i) => (
        <div key={i} className="card-surface p-3 sm:p-4" data-testid={`opening-hours-slot-${i}`}>
          <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
            <div className="flex flex-wrap gap-1.5">
              {DAYS_OF_WEEK.map((d) => {
                const active = (slot.days || []).includes(d.key);
                return (
                  <button
                    type="button"
                    key={d.key}
                    onClick={() => toggleDay(i, d.key)}
                    className={`text-xs px-2 py-1 rounded transition ${active ? "border" : "opacity-60"}`}
                    style={{
                      background: active ? "var(--brand-primary)" : "transparent",
                      color: active ? "#050505" : "var(--brand-text)",
                      borderColor: "var(--brand-border)",
                      borderWidth: 1,
                    }}
                    data-testid={`oh-day-${i}-${d.key}`}
                  >
                    {d.label_ro}
                  </button>
                );
              })}
            </div>
            <button type="button" onClick={() => removeSlot(i)} className="btn-ghost p-1 text-xs" data-testid={`oh-remove-${i}`}>
              Sterge
            </button>
          </div>
          <div className="flex items-center gap-2 text-xs">
            <span>Deschis:</span>
            <input
              type="time"
              value={slot.open || ""}
              onChange={(e) => update(i, { open: e.target.value })}
              className="brand-input text-xs py-1"
              data-testid={`oh-open-${i}`}
            />
            <span>—</span>
            <span>Inchis:</span>
            <input
              type="time"
              value={slot.close || ""}
              onChange={(e) => update(i, { close: e.target.value })}
              className="brand-input text-xs py-1"
              data-testid={`oh-close-${i}`}
            />
          </div>
        </div>
      ))}
      <button type="button" onClick={addSlot} className="btn-ghost text-sm" data-testid="opening-hours-add">
        + Adauga interval
      </button>
    </div>
  );
}
